<template>
    <div class="ProjectCreatePage">
        <DashboardSectionHeader title="Add Project">
            <Button to="/company/projects" class="link primary">Cancel</Button>
            <Button class="primary" @click="handleCreate" :disabled="submitPending">Create</Button>
        </DashboardSectionHeader>

        <ProjectForm ref="projectForm" v-bind.sync="project"/>

        <DashboardSectionHeader>
            <Button to="/company/projects" class="link primary">Cancel</Button>
            <Button class="primary" @click="handleCreate" :disabled="submitPending">Create</Button>
        </DashboardSectionHeader>
    </div>
</template>

<script>
import * as api from '@/api';
import DashboardSectionHeader from '@/components/DashboardSectionHeader';
import DashboardEditSection from '@/components/DashboardEditSection';
import ProjectForm from './components/ProjectForm';

export default {
    name: 'ProjectCreatePage',

    components: {
        DashboardSectionHeader,
        DashboardEditSection,
        ProjectForm,
    },

    data: () => ({
        project: {
            client: null,
            name: null,
            address: null,
            city: null,
            state: null,
            zip: null,
            firstName: null,
            lastName: null,
            email: null,
            phone: null,
            dumpSite: null,
            loadSite: null,
            rateType: 'hourly',
            hourlyRate: null,
            hourlyRateOptions: {
                precheckTime: false,
                mobilizationTime: false,
                standbyTime: false,
                demobilizationTime: false,
                postcheckTime: false,
            },
            materialRates: [],
            materials: [],
            mobilizationPrice: null,
            demobilizationPrice: null,
        },

        submitPending: false,
        submitError: null,
    }),

    methods: {
        async handleCreate() {
            if (!this.$refs.projectForm.validate()) {
                return;
            }

            this.submitPending = true;

            const company = this.$store.state.company.id;
            const res = await api.createProject({ ...this.project, company });
            this.submitPending = false;

            if (res.error) {
                this.submitError = res.error.message;
                return this.$awn.alert('Failed to create project');
            }

            this.submitError = null;
            this.$router.push(`/company/projects`);
        },
    },
}
</script>
